import React, {useId} from 'react';
import {useTranslation} from 'react-i18next';
import {factTypeDescKey} from './factConstants';

/**
 * Un rótulo de tipo de hecho que explica qué significa al pasar el mouse.
 *
 * Los once tipos son vocabulario nuestro, no del usuario: en el piloto con Bakián, «restricción»
 * hubo que explicarlo a mano en vivo (card GcSbgD7B). Un badge que dice una palabra sin definirla
 * le pide a la agencia que adivine con qué criterio la IA clasificó ese hecho.
 *
 * Es UN componente para las DOS superficies que muestran el tipo —el badge de la card y el
 * encabezado de grupo de la biblioteca—: si cada una escribiera su tooltip, tarde o temprano dirían
 * cosas distintas del mismo tipo.
 *
 * ⚠️ Los textos (`client_memory.fact_type_desc.*`) son el resumen en pantalla de las definiciones
 * que usa el EXTRACTOR (`document_extraction_service.py`, bloque «TIPOS»). Si allá cambia el
 * criterio de un tipo, este texto queda mintiendo: se actualizan juntos.
 */
export function FactTypeHelp({type, className, placement, children}) {
    const {t} = useTranslation();
    // El id del texto, para que el lector de pantalla lo anuncie como la descripción del rótulo y
    // no como un párrafo suelto que aparece de la nada.
    const descId = useId();
    return (
        // ⚠️ `tabIndex` y `aria-describedby` no son adorno: hasta el review del 10/09 el cartel salía
        // sólo con `:hover`, así que la definición de los once tipos era **inalcanzable con el
        // teclado y en táctil**. El `:focus-visible` de `.info-icon-container` ya sabe abrirlo —lo
        // que faltaba era un disparador que pudiera recibir el foco— y `.cmem-type-help` suma el
        // `:focus-within` que lo cubre en pantallas sin mouse. Hallazgo C-knob-14.
        <span className={`info-icon-container cmem-type-help ${className || ''}`}
              tabIndex={0} aria-describedby={descId}>
            {children}
            {/* `placement` es un modifier del tooltip canónico (`-below`, `-below-left`,
                `-below-right`), no una posición propia: la carta del mazo es `overflow: hidden` y
                el default —arriba y a la derecha del disparador— se le recorta. Sin `placement`
                queda exactamente como estaba en la cola clásica. */}
            <div className={`warning-tooltip ${placement || ''}`}>
                <div className="warning-tooltip-body">
                    <p className="warning-tooltip-text" id={descId}>{t(factTypeDescKey(type))}</p>
                </div>
            </div>
        </span>
    );
}

export default FactTypeHelp;
